/*
 * @Descripttion: 主页用的header
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-03-01 16:08:14
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-09-08 15:55:48
 */
import React from 'react'
import Logo from './images/logo.png'
import { Link, Redirect } from 'react-router-dom'
import './index.css'
import './index_mobile.css'
import { connect } from 'react-redux'
import { login, logout } from '../../service/loginaction'
class Header1 extends React.Component {
    state = {
        headertype: 1
    }
    componentDidMount() {
        let href = window.location.href
        if (href.indexOf('/Home') !== -1) {
            this.setState({ headertype: 1 })
        } else {
            this.setState({ headertype: 2 })
        }

    }
    componentDidUpdate() {
        console.log('2555555555')
    }
    render() {
        if (this.props.loginObj && this.props.loginObj.login && this.props.loginObj.token!==undefined) {
            return <Redirect  to='/Guide' />
        } else
            return (
                // <div>            
                <div className="hidden-scroll" >
                    <div className={`header-panel headertype-1`}
                    // style={{ height: 64,backgroundColor:this.state.headertype===1?'tranparent':'red' }}
                    >
                        <div className="header-white-panel"  ></div>
                        <div className="header-logo-panel"  >
                            <Link to='/Home'>
                                <img alt='logo' className="header-logo" src={Logo}/>
                            </Link>

                            <div className={'header-title-text'} >
                                <div className={'header-title-text-cn'} style={{ color: 'white' }}>
                                    陆地观测卫星共性应用支撑平台
                            </div>
                                <div className={'header-title-text-en'} style={{ color: 'white' }} >
                                Common application support platform for land observation satellite
                            </div>

                            </div>
                        </div>
                        <div style={{ flex: 3 }}>

                        </div>

                        <div className='header-loginpanel'>
                            <Link to='/UserLogin'>
                                <div className='header-login'>
                                    登录
                            </div>
                            </Link>
                            <Link to='/UserRegister'>
                                <div className='header-register'>
                                    {'注册'}
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
                // {/* {this.state.headertype !== 1 &&
                //     <div style={{ height: 64, width: '100%' }}></div>} */}
                // {/* </div> */}
            )
    }
}

/**
 * 
 * @param {*} state 代表外部传来的数据
 */
const mapState = (state) => ({ //返回值  对应的是  组件的props
    // loginStatus: state.loginreducer.loginstate,
    loginObj: state.userReducer.get('loginObj').toJS(),
    user: state.userReducer.get('user').toJS()
})
/**
 * 用来建立 UI 组件的参数到store.dispatch方法的映射。它定义了哪些用户的操作应该当作 Action，传给 Store。它可以是一个函数，也可以是一个对象。
 * @param {*} dispatch 
 * @param {*} ownProps 容器组件的props对象
 */
const mapDispatch = (dispatch, ownProps) => ({
    //组件中的方法名称 组件通过this.props.fucname(para1,para2)来调用方法
    // { type: 'increase' }定义了外部对这个方法的描述信息，
    // login: (userName, password) => dispatch({ type: 'login', userName: userName }),
    // logout: () => dispatch({ type: 'logout' })
    login: (param) => dispatch(login(param)),
    logout: () => dispatch(logout())
})
/**
 * connect方法接受两个参数： * mapStateToProps 和 mapDispatchToProps。它们定义了 UI 组件的业务逻辑。
 * mapStateToProps 负责输入逻辑，即将state映射到 UI 组件的参数（props），
 * mapDispatchToProps 负责输出逻辑，即将用户对 UI 组件的操作映射成 Action。
 */
export default connect(mapState, mapDispatch)(Header1);